
const TokenService = {
  getToken(TOKEN_KEY) {
    return localStorage.getItem(TOKEN_KEY);
  },

  saveToken(TOKEN_KEY, token) {
    localStorage.setItem(TOKEN_KEY, token);
  },

  removeToken(TOKEN_KEY) {
    localStorage.removeItem(TOKEN_KEY);
  }
}

export default TokenService;